export function compress(data: number[], width: number): number[] {
  if (data.length === 0 || width <= 0 || data.length === width) {
    return data
  }

  if (data.length > width) {
    const n = []
    const a = data.length / width
    for (let r = 0; r < width; r++) {
      const t = r * a
      const i = Math.max(0, Math.round(t))
      const o = Math.min(data.length, Math.round(t + a))
      let s = 0
      for (let n = i; n < o; n++) {
        s += data[n] ** 2
      }
      n.push(Math.sqrt(s / (o - i)))
    }
    return n
  }

  const n = []
  const a = (data.length - 1) / (width - 1)
  for (let r = 0; r < width; r++) {
    const t = r * a
    const i = Math.floor(t)
    const o = t - i
    const s =
      data[Math.min(data.length - 1, Math.ceil(t))] * o + data[i] * (1 - o)
    n.push(s)
  }

  return n
}
